import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  imgClient1 = require('../../../images/client01.jpg');
  imgClient2 = require('../../../images/client02.jpg');
  imgClient3 = require('../../../images/client03.jpg');
  imgClient4 = require('../../../images/client04.jpg');

  constructor() { }

  ngOnInit() {
  }

}
